import React, { useState } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="fixed top-0 left-0 w-full bg-gradient-to-r from-gray-800 to-black text-white shadow-lg py-5 z-50">
      <div className="container mx-auto flex justify-between items-center px-6">
        <div className="text-2xl font-bold text-cyan-400 hover:text-white transition-all duration-300 ease-in-out drop-shadow-glow">
          SKYZM
        </div>
        <div className="hidden md:flex space-x-6">
          <Link to="hero" smooth duration={300} className="cursor-pointer hover:text-blue-400 transition-all duration-300 ease-in-out">
            Home
          </Link>
          <Link to="services" smooth duration={300} className="cursor-pointer hover:text-blue-400 transition-all duration-300 ease-in-out">
            Services
          </Link>
          <Link to="contact" smooth duration={300} offset={-70} className="cursor-pointer hover:text-blue-400 transition-all duration-300 ease-in-out">
            Contact
          </Link>
        </div>
        <div className="md:hidden">
          <button 
            onClick={toggleMenu} 
            className="text-white" 
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            {isOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            )}
          </button>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden bg-gradient-to-r from-gray-800 to-black text-white py-4">
          <div className="flex flex-col items-center space-y-4">
            <Link to="hero" smooth duration={300} className="cursor-pointer hover:text-blue-400 transition-all duration-300 ease-in-out" onClick={toggleMenu}>
              Home
            </Link>
            <Link to="services" smooth duration={300} className="cursor-pointer hover:text-blue-400 transition-all duration-300 ease-in-out" onClick={toggleMenu}>
              Services
            </Link>
            <Link to="contact" smooth duration={300} offset={-70} className="cursor-pointer hover:text-blue-400 transition-all duration-300 ease-in-out" onClick={toggleMenu}>
              Contact
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;